/**
 * 웹에서 지원하는 라우트 패턴 (single source of truth).
 * - checkWebPageExists: URL 이동 전 페이지 존재 여부 확인
 * - 각 패키지 Navigator: 여기서 path를 import하여 ScreenItem에 사용
 *
 * 새 페이지 추가 시:
 * 1. 여기에 path 추가
 * 2. 해당 패키지 Navigator.tsx에서 import하여 ScreenItem 추가
 */
export const WEB_ROUTE_PATHS = {
  home: '/',
  goodsDetail: '/goods/:goodsId',
  marketHome: '/markets/:marketId',
  alarmSetting: '/mypage/alarm-setting',
  laboratory: '/mypage/laboratory',
  pointOfContact: '/mypage/point-of-contact',
  recentlyViewedGoods: '/mypage/recently-viewed-goods',
  screens: '/screens',
  fragmentScreens: '/screens/fragment',
} as const;

export type WebRoutePath =
  (typeof WEB_ROUTE_PATHS)[keyof typeof WEB_ROUTE_PATHS];

const routeRegexes = Object.values(WEB_ROUTE_PATHS).map(pattern => {
  const regexStr = '^' + pattern.replace(/:[\w]+/g, '[^/]+') + '$';
  return new RegExp(regexStr);
});

export const isKnownRoute = (path: string): boolean => {
  if (/\.\w+$/.test(path)) {
    return true;
  }
  const normalizedPath =
    path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
  return routeRegexes.some(regex => regex.test(normalizedPath));
};
